"use client";
import { useEffect, useState } from "react";

type W = { city: string; country: string; label: string; temp: number; desc: string; humidity: number; wind: number; };

function getIcon(desc: string) {
  const d = desc.toLowerCase();
  if (d.includes("clear") || d.includes("despej")) return "☀️";
  if (d.includes("rain") || d.includes("drizzle") || d.includes("lluvia")) return "🌧️";
  if (d.includes("snow") || d.includes("nieve")) return "❄️";
  if (d.includes("thunder") || d.includes("tormenta")) return "⛈️";
  if (d.includes("cloud") || d.includes("nub")) return "☁️";
  return "🌤️";
}

export default function Home() {
  const [weather, setWeather] = useState<W[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("Todas");
  const [updated, setUpdated] = useState("");

  useEffect(() => {
    fetch("/api/weather")
      .then(r => r.json())
      .then(data => {
        setWeather(data);
        setUpdated(new Date().toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" }));
        setLoading(false);
      })
      .catch(e => { console.error(e); setLoading(false); });
  }, []);

  const tabs = ["Todas", "Portugal", "España", "Francia", "Alemania"];
  const filtered = filter === "Todas" ? weather : weather.filter(w => w.label === filter);
  const groups = ["Portugal","España","Francia","Alemania"].map(l => ({ label: l, cities: filtered.filter(w => w.label === l) })).filter(g => g.cities.length > 0);
  const hero = weather[0];

  return (
    <div style={{ background: "#000", minHeight: "100vh", color: "#fff", fontFamily: "system-ui, sans-serif" }}>
      <nav style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem 2rem", borderBottom: "0.5px solid #222" }}>
        <div style={{ fontSize: 16, fontWeight: 500, letterSpacing: 3, textTransform: "uppercase" }}>Tempo</div>
        <div style={{ display: "flex", gap: "1.5rem" }}>
          {tabs.map(t => (
            <button key={t} onClick={() => setFilter(t)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, letterSpacing: "0.05em", color: filter === t ? "#fff" : "#666", fontWeight: filter === t ? 500 : 400 }}>{t}</button>
          ))}
        </div>
      </nav>

      {hero && (
        <div style={{ padding: "3rem 2rem 2.5rem", borderBottom: "0.5px solid #1a1a1a" }}>
          <div style={{ fontSize: 10, letterSpacing: "0.15em", textTransform: "uppercase", color: "#666", marginBottom: 8 }}>Tiempo ahora</div>
          <div style={{ fontSize: 28, fontWeight: 500, letterSpacing: -0.5, marginBottom: 4 }}>El clima de Europa</div>
          <div style={{ fontSize: 13, color: "#666", marginBottom: "2rem" }}>17 ciudades · actualizado a las {updated}</div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: "2rem" }}>
            <div>
              <div style={{ fontSize: 80, fontWeight: 300, letterSpacing: -4, lineHeight: 1 }}>{hero.temp}°</div>
              <div style={{ fontSize: 14, color: "#888", marginTop: 6 }}>{hero.city} · {hero.label}</div>
            </div>
            <div style={{ paddingBottom: 8 }}>
              <div style={{ fontSize: 22, marginBottom: 4 }}>{getIcon(hero.desc)}</div>
              <div style={{ fontSize: 13, color: "#aaa", textTransform: "capitalize" }}>{hero.desc}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "2rem", marginTop: "1.5rem" }}>
            <div><div style={{ fontSize: 14, marginBottom: 2 }}>{hero.humidity}%</div><div style={{ fontSize: 11, color: "#555" }}>Humedad</div></div>
            <div><div style={{ fontSize: 14, marginBottom: 2 }}>{hero.wind} km/h</div><div style={{ fontSize: 11, color: "#555" }}>Viento</div></div>
          </div>
        </div>
      )}

      {loading && <div style={{ padding: "4rem 2rem", textAlign: "center", color: "#555", fontSize: 13 }}>Cargando datos del tiempo...</div>}

      {groups.map(group => (
        <div key={group.label} style={{ padding: "1.5rem 2rem" }}>
          <div style={{ fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: "#555", marginBottom: "1rem" }}>{group.label}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 1, background: "#1a1a1a", borderRadius: 8, overflow: "hidden", border: "1px solid #1a1a1a" }}>
            {group.cities.map(w => (
              <div key={w.city} style={{ background: "#0d0d0d", padding: "1.25rem 1rem", cursor: "pointer" }}
                onMouseEnter={e => (e.currentTarget.style.background = "#161616")}
                onMouseLeave={e => (e.currentTarget.style.background = "#0d0d0d")}>
                <div style={{ fontSize: 20, marginBottom: 8 }}>{getIcon(w.desc)}</div>
                <div style={{ fontSize: 9, letterSpacing: "0.12em", textTransform: "uppercase", color: "#555", marginBottom: 4 }}>{w.country}</div>
                <div style={{ fontSize: 13, fontWeight: 500 }}>{w.city}</div>
                <div style={{ fontSize: 28, fontWeight: 300, letterSpacing: -1, margin: "8px 0 4px", color: w.temp > 25 ? "#e8e8e8" : "#88aacc" }}>{w.temp}°</div>
                <div style={{ fontSize: 11, color: "#666", textTransform: "capitalize" }}>{w.desc}</div>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div style={{ padding: "1rem 2rem", borderTop: "0.5px solid #1a1a1a", display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
        <span style={{ fontSize: 11, color: "#444" }}>© 2026 tempo.eu</span>
        <span style={{ fontSize: 11, color: "#444" }}>Datos: OpenWeatherMap</span>
      </div>
    </div>
  );
}
